import '../neb-button';

import { css, html } from 'lit';

import { parseDate } from '../../../../neb-utils/date-util';
import { centsToCurrency } from '../../../../neb-utils/formatters';

import NebTable, { ELEMENTS as ELEMENTS_BASE } from './neb-table';

export const ELEMENTS = {
  ...ELEMENTS_BASE,
  viewButtons: {
    selector: '[id^=view-button-]',
  },
};

const CONFIG = [
  {
    key: 'createdAt',
    label: 'Statement Date',
    flex: css`1 0 0`,
    mobile: true,
    formatter: value => (value ? parseDate(value).format('MMMM DD, YYYY') : ''),
  },
  {
    key: 'statementId',
    label: 'Statement ID',
    flex: css`.75 0 0`,
    mobile: true,
  },
  {
    key: 'groupStatements',
    label: 'Group Statement',
    flex: css`.75 0 0`,
    mobile: false,
    formatter: value => (value ? 'Yes' : 'No'),
  },
  {
    truncate: true,
    key: 'guarantorName',
    label: 'Guarantor',
    flex: css`1.25 0 0`,
    mobile: false,
  },
  {
    truncate: true,
    key: 'balance',
    label: 'Balance',
    flex: css`1 0 0`,
    mobile: true,
    formatter: amount => (amount ? centsToCurrency(amount) : '$0.00'),
  },
  {
    key: 'viewButton',
    label: '',
    flex: css`1 0 0`,
    mobile: false,
  },
];

class NebTableMyStatements extends NebTable {
  initState() {
    super.initState();
    this.config = CONFIG;
  }

  initHandlers() {
    super.initHandlers();

    this.handlers = {
      ...this.handlers,
      clickView: ({ name }) => {
        const rowIndex = name.split('-')[2];

        return this.onSelectRow(this.name, this.model[rowIndex], rowIndex);
      },
    };
  }

  static get styles() {
    return [
      super.styles,
      css`
        .button-container {
          width: 100%;
          display: flex;
          justify-content: flex-end;
        }
      `,
    ];
  }

  __renderViewButton(rowIndex) {
    return html`
      <div class="button-container">
        <neb-button
          id="view-button-${rowIndex}"
          name="view-button-${rowIndex}"
          label="View"
          .onClick="${this.handlers.clickView}"
        ></neb-button>
      </div>
    `;
  }

  renderDataCell(value, columnConfig, rowIndex) {
    switch (columnConfig.key) {
      case 'viewButton':
        return this.__renderViewButton(rowIndex);

      default:
        return super.renderDataCell(value, columnConfig);
    }
  }
}

customElements.define('neb-table-my-statements', NebTableMyStatements);
